import React, {Fragment} from "react";
import {RouteComponentProps} from "react-router";
import {css} from "@emotion/react";

import {mb, onDesktop, pb} from "@pg-design/helpers-css";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {Highlight, Text} from "@pg-design/text-module";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {ARTICLE_LIST_PAGE_SIZE} from "../../actions/fetch_article_list";
import {articleListBoxTitle, ArticleListBoxWide} from "./ArticleListBoxWide";

interface IProps {
    isFirstImageLazy?: boolean;
    articles: {
        author: {
            name: string;
        };
        date_published: string | null;
        gallery: (
            | {
                  image: {
                      g_img_65x65: string;
                      g_img_206x206: string;
                      g_img_349x239: string;
                  };
              }
            | undefined
        )[];
        id: number;
        lead: string | null;
        slug: string;
        title: string;
    }[];
    count: number;
    location: RouteComponentProps["location"];
    showHeader: boolean;
    hidePagination?: boolean;
    phrase?: string | string[];
}

export const ArticleListLatestList = (props: IProps) => {
    const {count, articles, hidePagination} = props;

    const {isMobile} = useUserDevice();

    const query = parseSearch(props.location.search);
    const maxPage = count ? Math.ceil(count / ARTICLE_LIST_PAGE_SIZE) : 1;
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(props.location.search), page >= 2 ? {page: page.toString()} : {});
        return appendQueryString(props.location.pathname, query);
    };

    return (
        <div css={pb(4)}>
            {props.showHeader ? (
                <Text as="h2" css={[mb(4), onDesktop(mb(5))]} variant="headline_2">
                    {props.phrase ? "Wyniki wyszukiwania dla frazy " : "Najnowsze artykuły"}
                    {!!props.phrase && (
                        <>
                            &quot;<Highlight>{props.phrase}</Highlight>&quot;
                        </>
                    )}
                </Text>
            ) : null}

            <div css={pb(4)}>
                {articles.map((article) => (
                    <ArticleListBoxWide
                        imageLoading="lazy"
                        articleTitle={
                            <Text css={articleListBoxTitle} as="h2" variant="headline_4">
                                {article.title}
                            </Text>
                        }
                        css={listItem}
                        article={article}
                        key={article.id}
                    />
                ))}
            </div>

            {!hidePagination && (
                <Pagination
                    getPageLink={getPageLink}
                    pageCount={maxPage}
                    currentPage={currentPage}
                    size={isMobile ? PaginationSize.MD : PaginationSize.LG}
                    siblingsCount={isMobile ? 0 : 1}
                />
            )}
        </div>
    );
};

const listItem = css`
    &:not(:last-of-type) {
        ${mb(2)};
    }
`;
